import script from "./GroupSelectLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupSelectLabel.vue?vue&type=script&setup=true&lang=js"

import "./GroupSelectLabel.vue?vue&type=style&index=0&id=8a3bef1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a3bef1a"]])

export default __exports__